import React from 'react';
import { Reveal } from './Reveal';
import { Shield, Lock, KeyRound, ShieldCheck, ServerCog, Eye, Globe2, FileCheck2 } from 'lucide-react';

const BADGES = [
  { icon: ShieldCheck, label: 'SOC 2 Type II', sub: 'audit in progress', color: '#FF6B1A' },
  { icon: Globe2, label: 'GDPR', sub: 'EU data ready', color: '#39FF14' },
  { icon: FileCheck2, label: 'ISO 27001', sub: 'on roadmap', color: '#FFB17A' },
  { icon: Eye, label: 'CCPA', sub: 'compliant', color: '#39FF14' },
];

const CONTROLS = [
  { icon: Lock, t: 'Encryption everywhere', d: 'TLS 1.3 in transit, AES-256 at rest. No prompt or conversation ever stored unencrypted.' },
  { icon: KeyRound, t: 'Auth grade', d: 'HTTP-only cookies, idempotent webhook handling, server-enforced plan gating. No tokens in localStorage.' },
  { icon: ServerCog, t: 'Tenant isolation', d: 'Every conversation, agent, and webhook event is scoped server-side to the owning tenant.' },
  { icon: Shield, t: 'Share-link safety', d: 'Public agent share endpoints intentionally exclude system prompts. Verified by automated tests.' },
];

export const TrustSecurity = () => {
  return (
    <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-2 pb-16">
      <Reveal>
        <div className="card-base p-6 lg:p-10 relative overflow-hidden">
          <div className="absolute -right-12 -top-16 h-56 w-56 rounded-full bg-[#FF6B1A]/15 blur-3xl pointer-events-none" />
          <div className="absolute -left-10 -bottom-16 h-44 w-44 rounded-full bg-[#39FF14]/10 blur-3xl pointer-events-none" />
          <div className="relative grid lg:grid-cols-12 gap-8 items-start">
            <div className="lg:col-span-5">
              <span className="text-[10px] uppercase tracking-widest text-[#39FF14]">// trust & security</span>
              <h2 className="display text-2xl md:text-4xl font-semibold mt-2 leading-tight">
                Built like infra. <span className="gradient-text">Trusted like infra.</span>
              </h2>
              <p className="text-white/65 mt-3 max-w-md text-sm md:text-base">
                Procurement-friendly from day one. We treat your data, your agents, and your customers’ conversations with the same gravity a fintech does.
              </p>
              <div className="mt-6 grid grid-cols-2 gap-3">
                {BADGES.map((b) => (
                  <div key={b.label} className="hairline rounded-xl p-3 flex items-center gap-3">
                    <div className="h-9 w-9 rounded-lg grid place-items-center hairline shrink-0" style={{ boxShadow: `0 0 16px ${b.color}33` }}>
                      <b.icon className="h-4 w-4" style={{ color: b.color }} />
                    </div>
                    <div>
                      <div className="text-sm font-semibold">{b.label}</div>
                      <div className="text-[10px] text-white/45 uppercase tracking-widest">{b.sub}</div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
            <div className="lg:col-span-7 grid sm:grid-cols-2 gap-3">
              {CONTROLS.map((c) => (
                <div key={c.t} className="card-base card-hover p-5">
                  <c.icon className="h-5 w-5 text-[#FF6B1A] mb-3" />
                  <div className="display text-base font-semibold">{c.t}</div>
                  <p className="text-sm text-white/65 mt-1">{c.d}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </Reveal>
    </section>
  );
};
